import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 5,
  },
  selectRoot: {
    marginRight: 10,
  },
  selectLabel: {
    fontSize: 14,
    textTransform: 'capitalize',
    color: theme.custom.darkBlue,
  },
  arrowIcon: {
    fontSize: '1.3rem',
  },
  listItem: {
    textTransform: 'capitalize',
  },
  centered: {
    display: 'flex',
    alignItems: 'center',
  },
  rangeWrapper: {
    paddingLeft: 5,
    paddingRight: 5,
  },
}));
